module.exports = __webpack_public_path__ + "static/media/Google-Reviews-transparent.75b2d62c.png";